



























































import { Component, Vue } from "vue-property-decorator";
import HeadTitle from "@/components/headerTitle.vue";
import SearchForm from "./components/SearchForm/index.vue";
import { orderColumns } from "./config";
import { apiMarginList, apiMarginBackBuyer, apiMarginDeduct } from "./service";
import LogModal from "./components/LogModal/index.vue";
@Component({
  components: {
    HeadTitle,
    SearchForm,
    LogModal,
  },
})
export default class Home extends Vue {
  public data: any = {};
  public loading = false;
  public columns = orderColumns;
  public pageSize = {
    size: 10,
    page: 1,
  };
  public info = {
    uid: "",
    order_num: "",
    bargain_id: "",
    status: "",
    s_time: "",
    e_time: "",
    export: 0,
    field: "",
  };
  public pageChange(index) {
    this.pageSize.page = index;
    this.init();
  }
  public sizeChange(size) {
    this.pageSize.size = size;
    if (this.pageSize.page == 1) {
      this.init();
    }
  }
  public searchClick(info) {
    this.info = info;
    this.pageSize.page = 1;
    this.init();
  }
  public mounted() {
    this.init();
  }
  public async init() {
    this.loading = true;
    const res = await apiMarginList({
      ...this.pageSize,
      ...this.info,
    });
    if (res.code === 0) {
      this.data = res.data;
    }
    this.loading = false;
  }
  public toExportExcel() {
    const windowUrl = this.$fn.exportExcelUrl(
      {
        ...this.info,
        ...this.pageSize,
        token: this.$fn.cookies.getToken(),
        export: 1,
        page: 1,
      },
      this.$HTTP_API.margin.marginList
    );
    window.open(windowUrl);
  }
  public onClick(val, uid, num?) {
    if (val === "BackBuyer") {
      this.$Modal.confirm({
        content: "确定要将该笔保证金退回给买家吗？",
        onOk: async () => {
          const res = await apiMarginBackBuyer({
            id: uid,
          });
          if (res.code === 0) {
            this.$Message.success(res.msg);
            this.init();
          }
        },
      });
    } else if (val === "Deduct") {
      this.$Modal.confirm({
        content: "确定要扣除该笔保证金吗？",
        onOk: async () => {
          const res = await apiMarginDeduct({
            id: uid,
          });
          if (res.code === 0) {
            this.$Message.success(res.msg);
            this.init();
          }
        },
      });
    } else if (val === "Log") {
      const $LogModal: any = this.$refs.LogModal;
      $LogModal.show(uid, num);
    }
  }
}
